import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { useNotificationSound } from '@/hooks/useNotificationSound';

const navItems = [
  { path: '/', label: 'Focus', icon: '◎' },
  { path: '/email', label: 'Email', icon: '📬' },
  { path: '/support', label: 'Support', icon: '🛟' },
  { path: '/contexts', label: 'Life', icon: '◐' },
  { path: '/settings', label: 'Settings', icon: '⚙' },
];

export function Layout() {
  const location = useLocation();

  // Initialize notification sound handler (listens for SW messages)
  useNotificationSound();

  return (
    <div className="flex flex-col min-h-screen bg-worm-950 safe-area-inset-top safe-area-inset-bottom">
      {/* Main content */}
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-surface border-t border-white/10 safe-area-inset-bottom">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={clsx(
                  'flex flex-col items-center justify-center w-full h-full',
                  'transition-colors duration-200',
                  isActive
                    ? 'text-accent-primary'
                    : 'text-white/50 hover:text-white/70'
                )}
              >
                <span className="text-xl mb-0.5">{item.icon}</span>
                <span className="text-xs font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
